import { render, staticRenderFns } from "./Clubs.vue?vue&type=template&id=42826a18&scoped=true"
import script from "./Clubs.vue?vue&type=script&lang=js"
export * from "./Clubs.vue?vue&type=script&lang=js"
import style0 from "./Clubs.vue?vue&type=style&index=0&id=42826a18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42826a18",
  null
  
)

export default component.exports